import { defineMessages } from 'react-intl';

export default defineMessages({
  navigateToPrevious: {
    defaultMessage: 'Navigate to previous order',
    description: 'Label for a button that navigates to the previous order',
    id: 'RsWN1Q',
  },
  navigateToNext: {
    defaultMessage: 'Navigate to next order',
    description: 'Label for a button that navigates to the next order',
    id: 'D/33LT',
  },
});
